import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=238a3697&scoped=true&"
import script from "./AccountNav.vue?vue&type=script&lang=js&"
export * from "./AccountNav.vue?vue&type=script&lang=js&"
import style0 from "./AccountNav.vue?vue&type=style&index=0&id=238a3697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a3697",
  null
  
)

export default component.exports